import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useI18n } from "../lib/i18n";

const pad = (n) => String(n).padStart(2, "0");

export function formatLeft(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const d = Math.floor(s / 86400);
  const hms = `${pad(Math.floor((s % 86400) / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
  return d ? `${d}d ${hms}` : hms;
}

export default function MaintenanceCountdown({ startAt, message, onReached }) {
  const { t } = useI18n();
  const [now, setNow] = useState(Date.now());
  const target = new Date(startAt).getTime();
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    if (now >= target) { const tm = setTimeout(onReached, 2000); return () => clearTimeout(tm); }
    return undefined;
  }, [now >= target]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="maintenance-countdown-banner" className="bg-[#D4AF37] text-[#101114] text-xs sm:text-sm font-bold px-4 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
      <Clock size={16} />
      <span>{t("maint.countdown")}</span>
      <span data-testid="maintenance-countdown-time" className="font-mono bg-[#101114] text-[#D4AF37] rounded-sm px-2 py-0.5">{formatLeft(target - now)}</span>
      <span className="font-normal">({new Date(startAt).toLocaleString()})</span>
      {message && <span className="font-normal w-full sm:w-auto">{message}</span>}
    </div>
  );
}
